export const additionalSounds = [
    {
        src: "sounds/click.mp3",
        id: "click",
    },
];
